import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faTable } from '@fortawesome/pro-regular-svg-icons/faTable';
import type { TableWidgetModel, TableWidgetState } from 'src/models/TableWidgetModel';
import { TableWidgetModelImpl } from 'src/models/TableWidgetModel/impl';

export const tableWidgetDefinition: SelfOwnedWidgetDefinition<TableWidgetState, TableWidgetModel> = {
    type: 'table' as const,
    nameKey: 'widgets::table::name' as const,
    roles: ['widgets::table'],
    icon: faTable,
    category: 'widgets::categories::misc' as const,
    widgetClass: TableWidgetModelImpl,
};
